import React from 'react';
import * as Yup from "yup";
import { Paper, withStyles } from '@material-ui/core';
import AuthServiceForm from './AuthServiceForm'
import { BackButton, hasPermission } from '../../sc-utilities';
import { connect } from "react-redux";
import * as actions from "./store/authServiceActions";
import History from "../../../History";
import config from "../../../config/config";

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        paddingRight: theme.spacing(6),
        margin: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            paddingRight: 0,
        }
    }

});

const AuthServiceCreate = props => {
    const { permissions, activeCustomer, translations, classes, onCreateAuthService } = props;

    const handleSubmit = async data => {
        let objectToSend = { ...data };
        let result = await onCreateAuthService({ ...objectToSend, ActiveCustomerID: activeCustomer });
        if (result) {
            History.goBack();
        }
    };

    let initialValues = {
        Name: "",
        Type: "",
        Active: false,
        BaseURL: "",
        ClientID: "",
        ClientSecret: "",
        GrantTypes: "authorization_code",
        ResponseTypes: "code",
        RedirectURIs: `${config.backend_url}/openid/callback`,
        AutoCreateTechnicalUser: false,
        TechnicalUserNameFormat: "{FirstName}_{LastName}-{UserID}",
        TechnicalUserDefaultFirstName: "Technical",
        TechnicalUserDefaultLastName: "User"
    };

    let formSettings = {
        Validation: {
            Name: Yup.string().required("Required"),
            Type: Yup.string().required("Required"),
            Active: Yup.boolean().required("Required"),
            BaseURL: Yup.string().required("Required"),
            ClientID: Yup.string().when('Type', {
                is: 'openid',
                then: Yup.string().required("Required"),
            }),
            ClientSecret: Yup.string().when('Type', {
                is: 'openid',
                then: Yup.string().required("Required"),
            }),
            GrantTypes: Yup.string().when('Type', {
                is: 'openid',
                then: Yup.string().required("Required"),
            }),
            ResponseTypes: Yup.string().when('Type', {
                is: 'openid',
                then: Yup.string().required("Required"),
            }),
            RedirectURIs: Yup.string().when('Type', {
                is: 'openid',
                then: Yup.string().required("Required"),
            }),
            AutoCreateTechnicalUser: Yup.boolean().when('Type', {
                is: 'openid',
                then: Yup.boolean().required("Required"),
            }),
            TechnicalUserNameFormat: Yup.string().when('AutoCreateTechnicalUser', {
                is: true,
                then: Yup.string().required("Required"),
            }),
            TechnicalUserDefaultFirstName: Yup.string().when('AutoCreateTechnicalUser', {
                is: true,
                then: Yup.string().required("Required"),
            }),
            TechnicalUserDefaultLastName: Yup.string().when('AutoCreateTechnicalUser', {
                is: true,
                then: Yup.string().required("Required"),
            })
        },
        FormTitle: translations['create_auth_service'] || 'Create Authorization Service',
        ButtonSubmit: hasPermission(permissions, "auth_service_create") ? {
            Title: translations["save"] || "SAVE",
            Color: 'primary'
        } : null
    };
    return (
        <Paper className={classes.root}>
            {BackButton(translations)}
            <AuthServiceForm
                formSettings={formSettings}
                initialValues={initialValues}
                handleSubmit={handleSubmit}
                translations={translations}
            />
        </Paper>
    )
}
const mapStateToProps = state => {
    return {
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        permissions: state?.core?.login?.permissions || [],
        translations: state?.translate?.translations?.activeTranslations || {},
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onCreateAuthService: authService => dispatch(actions.createAuthService(authService))
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(AuthServiceCreate));
